type ColorPalette = {
  'blue-ribbon': {
    500: string;
    900: string;
  };
  primary: {
    main: string;
    light: string;
    dark: string;
    states: {
      outiliedBorder: string;
      selected: string;
      focusVisible: string;
    };
  };
  orange: {
    50: string;
    100: string;
    200: string;
    300: string;
    350: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    850: string;
    900: string;
  };
  'mint-green': {
    50: string;
    100: string;
    200: string;
    250: string;
    300: string;
    400: string;
    600: string;
    700: string;
    800: string;
    950: string;
  };
  customPrimary: {
    focusVisible: string;
  };
  text: {
    primary: string;
    secondary: string;
  };
  background: string;
  gray: {
    50: string;
    100: string;
  };
  common: {
    black: string;
    white: string;
  };
};

export const colors: ColorPalette = {
  'blue-ribbon': {
    500: '#1E99FF',
    900: '#0D459B',
  },
  primary: {
    main: '#00C056',
    light: '#70FFB5',
    dark: '#076033',
    states: {
      outiliedBorder: '#00C05680',
      selected: '#00C05614',
      focusVisible: '#00C0564D',
    },
  },
  orange: {
    50: '#FFF3E0',
    100: '#FFE0B2',
    200: '#ffcb7f',
    300: '#FFB74D',
    350: '#fea726',
    400: '#FFA726',
    500: '#fa8a00',
    600: '#FB8C00',
    700: '#F57C00',
    800: '#EF6C00',
    850: '#ee6b00',
    900: '#E65100',
  },
  'mint-green': {
    50: '#EDFFF5',
    100: '#D5FFE9',
    200: '#AEFFD5',
    250: '#adfed5',
    300: '#70FFB5',
    400: '#71feb0',
    600: '#00C056',
    700: '#07743d',
    800: '#06753C',
    950: '#00371B',
  },
  customPrimary: {
    focusVisible: '#0679FF4D',
  },
  text: {
    primary: '#000000DE',
    secondary: '#00000099',
  },
  background: '#F7F7F7',
  gray: {
    50: '#F3F3F3',
    100: '#F5F5F5',
  },
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
} as const;
